<template>
  <v-dialog v-model="visible" max-width="500" persistent>
    <v-card>
      <v-card-title
        class="d-flex justify-space-between align-center py-0"
        style="background-color: #13795B; height: 56px !important;"
      >
        <div
          class="text-h6 text-medium-emphasis ps-2"
          style="color: white !important;"
        >
          {{ $t('message') }}
        </div>
        <v-btn icon variant="text" @click="handleCancel">
          <v-icon class="text-white">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="text-body text-center pa-4 preserve-newline">
        <div>
          {{ message }}
        </div>
        <div v-if="htmlText" v-html="htmlText"></div>
      </v-card-text>
      <v-card-actions class="my-2 d-flex justify-center">
        <template v-if="type === 'confirm' || type === 'delete'">
          <v-btn class="custom-btn-gray button-common me-2" :text="$t('cancel')" @click="handleCancel" />
          <v-btn :class="okBtnClass" text="OK" @click="handleOk" />
        </template>
        <template v-else>
          <v-btn class="custom-btn-green button-common" text="OK" @click="handleOk" />
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
const visible = ref(false)
const message = ref('')
const type = ref<'default' | 'confirm' | 'delete'>('default')
let okAction: (() => void) | null = null
let cancelAction: (() => void) | null = null
const htmlText = ref<string | undefined>()

function show(
  msg: string,
  onOk?: () => void,
  dialogType: 'default' | 'confirm' | 'delete' = 'default',
  onCancel?: () => void,
  html?: string,
) {
  message.value = msg
  okAction = onOk ?? null
  cancelAction = onCancel ?? null
  type.value = dialogType
  visible.value = true
  htmlText.value = html
}

function handleOk() {
  okAction?.()
  visible.value = false
}

function handleCancel() {
  cancelAction?.()
  visible.value = false
}

const titleStyle = computed(() => {
  switch (type.value) {
    case 'delete':
      return { backgroundColor: '#842029' }
    case 'confirm':
      return { backgroundColor: '#0c5460' }
    default:
      return { backgroundColor: '#13795B' }
  }
})

const okBtnClass = computed(() => {
  return type.value === 'delete'
    ? 'custom-btn-red button-common'
    : 'custom-btn-green button-common'
})

defineExpose({ show, handleCancel })
</script>

<style scoped>
.text-body {
  text-align: center;
  padding: 16px 24px;
  font-size: 24px;
}
.custom-btn-gray {
  background-color: gray;
  color: white;
  width: 120px;
}
.custom-btn-green {
  background-color: #198754;
  color: white;
  width: 120px;
}
.custom-btn-red {
  background-color: #dc3545;
  color: white;
  width: 120px;
}
.preserve-newline {
  white-space: pre-line;
}
</style>